import { createUserWithEmailAndPassword, onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { getFirebaseAuth, isFirebaseConfigured } from "./firebaseApp";
import { createAccountProfile } from "./profileService";

const requireAuth = () => {
	const auth = getFirebaseAuth();
	if (!isFirebaseConfigured || !auth) {
		throw new Error("Firebase is not configured. Add VITE_FIREBASE_* values to .env.local.");
	}
	return auth;
};

export const subscribeToAuth = (callback) => {
	if (!isFirebaseConfigured) {
		callback(null);
		return () => {};
	}

	return onAuthStateChanged(requireAuth(), callback);
};

export const signUpWithEmail = async (email, password, username = "") => {
	const credential = await createUserWithEmailAndPassword(requireAuth(), email, password);
	await createAccountProfile({ user: credential.user, username: username.trim() || null });
	return credential.user;
};

export const signInWithEmail = async (email, password) => {
	const credential = await signInWithEmailAndPassword(requireAuth(), email, password);
	return credential.user;
};

export const logout = () => signOut(requireAuth());
